export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  rating: number;
  views: number;
  updateDate: string;
  status: string;
  description: string;
  tags: string[];
  chapters: { id: number; title: string; date: string }[];
}

export const comics: Comic[] = [
  {
    id: 1,
    title: "秘密花园",
    author: "金秀雅",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20cover%20style%20illustration%20featuring%20a%20young%20woman%20with%20long%20dark%20hair%20in%20a%20mysterious%20garden%20filled%20with%20glowing%20flowers%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20watercolor%20and%20ink%20style%2C%20clean%20composition%2C%20digital%20art%20with%20Korean%20manhwa%20aesthetic%2C%20elegant%20and%20dreamy%20mood%2C%20light%20cream%20background%20with%20subtle%20floral%20elements&width=400&height=560&seq=hanman-cover-001&orientation=portrait",
    category: "恋爱",
    categorySlug: "romance",
    rating: 9.2,
    views: 1285000,
    updateDate: "2026-08-04",
    status: "连载中",
    description: "一段发生在秘密花园中的浪漫故事。女主角林素恩偶然发现了一座隐藏在城市中央的秘密花园，在那里她遇见了神秘的花园主人。两个完全不同世界的人，因为一座花园而相遇，展开了一段美丽的爱情故事。",
    tags: ["恋爱", "都市", "治愈", "秘密"],
    chapters: [
      { id: 101, title: "第1话 - 花园的入口", date: "2025-11-15" },
      { id: 102, title: "第2话 - 神秘的男人", date: "2025-11-22" },
      { id: 103, title: "第3话 - 月光下的约定", date: "2025-11-29" },
      { id: 104, title: "第4话 - 雨中的相遇", date: "2025-12-06" },
      { id: 105, title: "第5话 - 心跳的秘密", date: "2025-12-13" },
    ]
  },
  {
    id: 2,
    title: "剑与魔法",
    author: "李俊昊",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20fantasy%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20landscape%20with%20floating%20crystals%20and%20ancient%20ruins%2C%20epic%20fantasy%20art%2C%20vibrant%20magical%20effects%2C%20digital%20painting%20style%2C%20Korean%20manhwa%20aesthetic%2C%20dramatic%20lighting%20with%20warm%20golden%20and%20cool%20blue%20tones%2C%20adventure%20mood%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-002&orientation=portrait",
    category: "奇幻",
    categorySlug: "fantasy",
    rating: 9.5,
    views: 2356000,
    updateDate: "2026-08-05",
    status: "连载中",
    description: "在一个魔法与剑并存的世界里，年轻的剑士艾伦踏上了寻找传说之剑的旅程。途中他遇到了各种伙伴，经历了无数冒险，逐渐揭开了这个世界隐藏的真相。",
    tags: ["奇幻", "冒险", "魔法", "成长"],
    chapters: [
      { id: 201, title: "第1话 - 启程之日", date: "2025-10-01" },
      { id: 202, title: "第2话 - 魔法的试炼", date: "2025-10-08" },
      { id: 203, title: "第3话 - 暗影来袭", date: "2025-10-15" },
    ]
  },
  {
    id: 3,
    title: "城市猎人",
    author: "朴志勋",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20mysterious%20man%20in%20a%20dark%20coat%20standing%20on%20a%20rooftop%20overlooking%20a%20neon-lit%20cityscape%20at%20night%2C%20noir%20atmosphere%2C%20action%20thriller%20vibe%2C%20dramatic%20shadows%2C%20Korean%20manhwa%20aesthetic%2C%20digital%20art%2C%20cool%20blue%20and%20warm%20orange%20accent%20colors%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-003&orientation=portrait",
    category: "动作",
    categorySlug: "action",
    rating: 8.9,
    views: 1892000,
    updateDate: "2026-08-03",
    status: "连载中",
    description: "白天是普通的上班族，夜晚则化身为城市猎人。主角郑宇镇有着不为人知的过去，他用自己特殊的能力追踪城市中的罪犯，揭开了一个又一个惊天阴谋。",
    tags: ["动作", "悬疑", "都市", "英雄"],
    chapters: [
      { id: 301, title: "第1话 - 面具之下", date: "2025-09-20" },
      { id: 302, title: "第2话 - 猎人的猎物", date: "2025-09-27" },
    ]
  },
  {
    id: 4,
    title: "不可思议的教室",
    author: "韩志旼",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20group%20of%20high%20school%20students%20laughing%20together%20in%20a%20bright%20classroom%20with%20colorful%20school%20supplies%20and%20funny%20expressions%2C%20comedy%20slice%20of%20life%2C%20vibrant%20and%20cheerful%20colors%2C%20Korean%20manhwa%20aesthetic%2C%20digital%20art%2C%20warm%20and%20playful%20atmosphere%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-004&orientation=portrait",
    category: "搞笑",
    categorySlug: "comedy",
    rating: 9.1,
    views: 1567000,
    updateDate: "2026-08-04",
    status: "连载中",
    description: "一所普通高中里，一群性格迥异的学生和老师之间发生的爆笑日常。每一集都有令人捧腹的笑点，同时也有着温暖人心的校园故事。",
    tags: ["搞笑", "校园", "日常", "青春"],
    chapters: [
      { id: 401, title: "第1话 - 转学生的第一天", date: "2025-11-01" },
      { id: 402, title: "第2话 - 食堂大作战", date: "2025-11-08" },
      { id: 403, title: "第3话 - 体育课的灾难", date: "2025-11-15" },
      { id: 404, title: "第4话 - 考试周的疯狂", date: "2025-11-22" },
    ]
  },
  {
    id: 5,
    title: "第七层",
    author: "崔敏浩",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20dark%20mysterious%20apartment%20building%20with%20one%20lit%20window%20on%20the%20seventh%20floor%2C%20psychological%20thriller%20atmosphere%2C%20eerie%20and%20suspenseful%2C%20muted%20dark%20tones%20with%20a%20single%20warm%20light%2C%20Korean%20manhwa%20aesthetic%2C%20digital%20art%2C%20mysterious%20and%20unsettling%20mood%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-005&orientation=portrait",
    category: "悬疑",
    categorySlug: "thriller",
    rating: 9.3,
    views: 2015000,
    updateDate: "2026-08-05",
    status: "连载中",
    description: "一栋普通的公寓楼里，第七层住着七个性格各异的住户。当其中一人离奇死亡后，剩下的六人开始互相怀疑。每个人都有自己的秘密，而真相比想象中更加可怕。",
    tags: ["悬疑", "惊悚", "推理", "心理"],
    chapters: [
      { id: 501, title: "第1话 - 新的邻居", date: "2025-10-10" },
      { id: 502, title: "第2话 - 第一个死者", date: "2025-10-17" },
    ]
  },
  {
    id: 6,
    title: "星之彼岸",
    author: "尹恩惠",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20beautiful%20couple%20standing%20under%20a%20starry%20night%20sky%20with%20a%20galaxy%20reflected%20in%20a%20lake%2C%20romantic%20fantasy%20style%2C%20soft%20dreamy%20colors%2C%20ethereal%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20digital%20art%2C%20gentle%20and%20emotional%20mood%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-006&orientation=portrait",
    category: "恋爱",
    categorySlug: "romance",
    rating: 8.8,
    views: 987000,
    updateDate: "2026-08-02",
    status: "已完结",
    description: "天文系学生韩智恩在观测星空时，意外遇见了一位自称来自遥远星系的少年。两个来自不同世界的人，在星光下展开了一段跨越星际的浪漫爱情。",
    tags: ["恋爱", "科幻", "治愈", "星空"],
    chapters: [
      { id: 601, title: "第1话 - 流星雨之夜", date: "2025-08-01" },
      { id: 602, title: "第2话 - 来自星星的你", date: "2025-08-08" },
      { id: 603, title: "第3话 - 星际的距离", date: "2025-08-15" },
      { id: 604, title: "最终话 - 彼岸的星光", date: "2025-10-30" },
    ]
  },
  {
    id: 7,
    title: "魔王学院",
    author: "金泰亨",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20powerful%20demon%20lord%20character%20in%20a%20magical%20academy%20uniform%20with%20dark%20wings%20and%20glowing%20red%20eyes%2C%20dark%20fantasy%20style%2C%20gothic%20architecture%20in%20background%2C%20dramatic%20contrast%20lighting%2C%20Korean%20manhwa%20aesthetic%2C%20digital%20art%2C%20cool%20and%20mysterious%20mood%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-007&orientation=portrait",
    category: "奇幻",
    categorySlug: "fantasy",
    rating: 9.0,
    views: 1678000,
    updateDate: "2026-08-04",
    status: "连载中",
    description: "曾是史上最强魔王的他，在战败后转世成为了一所魔法学院的学生。在这个充满魔法与阴谋的学院里，曾经的最强魔王将如何重新崛起？",
    tags: ["奇幻", "学院", "魔王", "转世"],
    chapters: [
      { id: 701, title: "第1话 - 魔王的重生", date: "2025-12-01" },
      { id: 702, title: "第2话 - 入学考试", date: "2025-12-08" },
      { id: 703, title: "第3话 - 第一堂课", date: "2025-12-15" },
    ]
  },
  {
    id: 8,
    title: "蓝色大海的传说",
    author: "张美兰",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20mermaid%20with%20long%20blue%20hair%20sitting%20on%20a%20rock%20by%20the%20ocean%20under%20moonlight%2C%20beautiful%20fantasy%20romance%20style%2C%20shimmering%20ocean%20waves%2C%20ethereal%20and%20magical%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20digital%20art%2C%20dreamy%20blue%20and%20silver%20tones%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-008&orientation=portrait",
    category: "恋爱",
    categorySlug: "romance",
    rating: 9.4,
    views: 3120000,
    updateDate: "2026-08-05",
    status: "连载中",
    description: "一个关于人鱼与人类之间跨越种族的爱情故事。海洋学家李俊秀在研究海洋生物时，意外救下了一位美丽的人鱼公主。从此，他的生活发生了天翻地覆的变化。",
    tags: ["恋爱", "奇幻", "人鱼", "海洋"],
    chapters: [
      { id: 801, title: "第1话 - 海滩的邂逅", date: "2025-06-15" },
      { id: 802, title: "第2话 - 海底的秘密", date: "2025-06-22" },
      { id: 803, title: "第3话 - 两个世界", date: "2025-06-29" },
      { id: 804, title: "第4话 - 暴风雨来临", date: "2025-07-06" },
    ]
  },
  {
    id: 9,
    title: "血色玫瑰",
    author: "赵贤宇",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20woman%20in%20an%20elegant%20red%20dress%20surrounded%20by%20rose%20petals%20with%20a%20dark%20mysterious%20expression%2C%20drama%20thriller%20style%2C%20deep%20red%20and%20black%20color%20palette%2C%20elegant%20yet%20dangerous%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20digital%20art%2C%20intense%20and%20passionate%20mood%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-009&orientation=portrait",
    category: "剧情",
    categorySlug: "drama",
    rating: 8.7,
    views: 876000,
    updateDate: "2026-08-03",
    status: "连载中",
    description: "复仇、爱情与家族的纠葛。姜秀妍为了调查父亲的死因，潜入韩国最大的财阀家族。在这个充满谎言与背叛的世界里，她能否找到真相并完成复仇？",
    tags: ["剧情", "复仇", "财阀", "爱情"],
    chapters: [
      { id: 901, title: "第1话 - 葬礼之后", date: "2025-11-20" },
      { id: 902, title: "第2话 - 潜入", date: "2025-11-27" },
    ]
  },
  {
    id: 10,
    title: "美食的诱惑",
    author: "郑智薰",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20cheerful%20chef%20holding%20a%20beautifully%20plated%20dish%20in%20a%20warm%20cozy%20kitchen%2C%20food%20comedy%20style%2C%20mouth%20watering%20food%20art%2C%20warm%20and%20inviting%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20digital%20art%2C%20delicious%20and%20joyful%20mood%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-010&orientation=portrait",
    category: "搞笑",
    categorySlug: "comedy",
    rating: 9.0,
    views: 1234000,
    updateDate: "2026-08-04",
    status: "连载中",
    description: "一个对美食有着极致追求的厨师，用他的料理征服了无数食客的心。每一集都围绕一道美食展开，在欢笑中感受美食的魅力。",
    tags: ["搞笑", "美食", "治愈", "日常"],
    chapters: [
      { id: 1001, title: "第1话 - 一碗面的哲学", date: "2025-09-05" },
      { id: 1002, title: "第2话 - 甜品的魔力", date: "2025-09-12" },
      { id: 1003, title: "第3话 - 寿司的艺术", date: "2025-09-19" },
    ]
  },
  {
    id: 11,
    title: "黑月之夜",
    author: "宋慧乔",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20vampire%20character%20with%20pale%20skin%20and%20dark%20elegant%20clothing%20standing%20in%20moonlight%20in%20a%20gothic%20setting%2C%20dark%20romance%20style%2C%20mysterious%20and%20seductive%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20digital%20art%2C%20silver%20moonlight%20and%20deep%20shadows%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-011&orientation=portrait",
    category: "耽美",
    categorySlug: "bl",
    rating: 9.6,
    views: 2890000,
    updateDate: "2026-08-05",
    status: "连载中",
    description: "在一个被吸血鬼统治的黑暗世界里，人类少年林月被选为吸血鬼王的血仆。然而，命运却让两人之间产生了超越种族的情感。一段禁忌之恋在黑暗中悄然绽放。",
    tags: ["耽美", "吸血鬼", "黑暗", "爱情"],
    chapters: [
      { id: 1101, title: "第1话 - 血的契约", date: "2025-07-10" },
      { id: 1102, title: "第2话 - 月下的相遇", date: "2025-07-17" },
      { id: 1103, title: "第3话 - 禁忌之恋", date: "2025-07-24" },
      { id: 1104, title: "第4话 - 觉醒", date: "2025-07-31" },
    ]
  },
  {
    id: 12,
    title: "推理社的日常",
    author: "刘海镇",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20style%20illustration%20of%20a%20group%20of%20students%20in%20a%20school%20clubroom%20examining%20clues%20with%20magnifying%20glasses%2C%20mystery%20comedy%20style%2C%20bright%20and%20playful%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20digital%20art%2C%20warm%20school%20setting%2C%20clean%20cream%20background&width=400&height=560&seq=hanman-cover-012&orientation=portrait",
    category: "悬疑",
    categorySlug: "thriller",
    rating: 8.6,
    views: 654000,
    updateDate: "2026-08-02",
    status: "连载中",
    description: "高中推理社的五名成员在校园里解决各种神秘事件。从消失的考试试卷到图书馆的幽灵传说，每一个案件都充满了智慧与幽默。",
    tags: ["悬疑", "校园", "推理", "青春"],
    chapters: [
      { id: 1201, title: "第1话 - 推理社的诞生", date: "2025-12-10" },
      { id: 1202, title: "第2话 - 消失的试卷", date: "2025-12-17" },
    ]
  },
];